import { useState } from 'react';

import { useDucatClient } from '@/context/DucatClientCtx';

import { handleCookieConsentFromFirstWindow, handleCookieConsentFromSecondWindow, handleCookieConsentNotAllow } from './cookie.utils';

export const useCookiePolicy = (isCookieConsent: boolean | undefined, isPosthogIdentify: boolean | undefined) => {
  const { walletAddress, walletType, selectedNetwork, pubkey: walletPubkey } = useDucatClient();

  const [isCookieConsentAllowed, setIsCookieConsentAllowed] = useState<boolean | undefined>(isCookieConsent);
  const [isPosthogIdentifyAllowed, setIsPosthogIdentifyAllowed] = useState<boolean | undefined>(isPosthogIdentify);

  const handleAllowFromFirstWindow = () => {
    setIsCookieConsentAllowed(true);
    setIsPosthogIdentifyAllowed(true);

    handleCookieConsentFromFirstWindow(walletAddress, walletPubkey, walletType, selectedNetwork);
  };

  const handleAllowFromSecondWindow = () => {
    handleCookieConsentFromSecondWindow();

    setIsCookieConsentAllowed(true);
    setIsPosthogIdentifyAllowed(false);
  };

  const handleNotAllow = () => {
    handleCookieConsentNotAllow();

    setIsPosthogIdentifyAllowed(false);
    setIsCookieConsentAllowed((prevState) => {
      if (prevState === undefined) {
        return false;
      }

      if (prevState === false) {
        window.location.href = 'https://ducatprotocol.com/';

        return prevState;
      }

      return prevState;
    });
  };

  return {
    isCookieConsentAllowed,
    isPosthogIdentifyAllowed,
    setIsCookieConsentAllowed,
    setIsPosthogIdentifyAllowed,
    handleAllowFromSecondWindow,
    handleAllowFromFirstWindow,
    handleNotAllow,
  };
};
